import axiosClient from "@/api/common/axiosClient.ts";

export const changeEmail = ({
  email,
  password,
}: {
  email: string;
  password: string;
}) => {
  return axiosClient.put("users/email_update/", {
    email,
    password,
  });
};

export type ChangeEmailErrorType = {
  detail: string;
};
